module.exports = __webpack_public_path__ + "img/UI_design.7abafba1.jpg";